import React, { useEffect, useState } from "react";
import { motion, useAnimationControls } from "framer-motion";
import classes from "./AuthModal.module.css";
import { InputText } from "primereact/inputtext";
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import { resetAuthModal, setAuthModal } from "../../Slices/authModalSlice";
import { toast } from "react-toastify";
import { useLoginMutation, useSignupMutation } from "../../Slices/httpSlice";
import { setUser } from "../../Slices/userSlice";
import Spinner from "../Loaders/Spinner";

const AuthModal = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  function resetStates() {
    setUsername("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
  }

  const [signup, { isLoading: signupLoading }] = useSignupMutation();
  const [login, { isLoading: loginLoading }] = useLoginMutation();

  const dispatch = useAppDispatch();
  const { authModal, authModalType } = useAppSelector(
    (state) => state.authModalSlice
  );

  const variants = {
    hidden: {
      opacity: 0,
      scale: 0,
    },
    visible: {
      opacity: 1,
      scale: 1,
    },
  };

  const controls = useAnimationControls();

  useEffect(() => {
    if (authModal) {
      resetStates();
      controls.start("visible");
      document.body.style.overflow = "hidden";
    }
    resetStates();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [authModal, authModalType]);

  const closeHandler = () => {
    dispatch(resetAuthModal());
    controls.start("hidden");
  };

  const signupHandler = async (e: any) => {
    e.preventDefault();
    if (authModalType !== "signup") {
      toast.error("တစ်ခုခုမှားသွားသည်၊ ကျေးဇူးပြု၍ ထပ်စမ်းကြည့်ပါ။");
      return;
    }
    if (
      username.trim().length == 0 &&
      email.trim().length == 0 &&
      password.trim().length == 0 &&
      confirmPassword.trim().length == 0
    ) {
      toast.error("ထည့်သွင်းသည့်အကွက်များသည် ဗလာမဖြစ်နိုင်ပါ။");
      return;
    }
    if (password.length < 8) {
      toast.error("စကားဝှက်သည် အနည်းဆုံး စာလုံး 8 လုံး ရှည်ရပါမည်။");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("စကားဝှက်များ မတိုက်ဆိုင်ပါ။");
      return;
    }
    try {
      const response: any = await signup({ username, email, password });
      console.log(response, "r");
      console.log(response?.data?.result, "reult");
      console.log(response?.error?.status === 400, "error");
      if (response?.error?.status === 400) {
        console.log("enter here...");
        console.log(response?.error?.data?.error?.error, "e");
        toast.error(
          response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data ||
            response?.error?.message ||
            "Something Went Wrong!"
        );
      } else {
        console.log("enter here...");
        dispatch(setUser(response?.data?.result));
        toast.success("အောင်မြင်စွာ စာရင်းသွင်းပြီးပါပြီ။");
        resetStates();
        closeHandler();
      }
    } catch (error: any) {
      console.log(error, "err");
      toast.error(error?.response?.data?.message);
    }
  };

  const loginHandler = async (e: any) => {
    e.preventDefault();
    if (authModalType !== "signin") {
      toast.error("တစ်ခုခုမှားသွားသည်၊ ကျေးဇူးပြု၍ ထပ်စမ်းကြည့်ပါ။");
      return;
    }
    if (email.trim().length == 0 && password.trim().length == 0) {
      toast.error("ထည့်သွင်းသည့်အကွက်များသည် ဗလာမဖြစ်နိုင်ပါ။");
      return;
    }
    try {
      const response: any = await login({ email, password });
      console.log(response, "r");
      console.log(response?.data?.result, "reult");
      console.log(response?.error?.status === 400, "error");
      if (response?.error?.status === 400) {
        console.log("enter here...");
        console.log(response?.error?.data?.error?.error, "e");
        toast.error(
          response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data ||
            response?.error?.message ||
            "Something Went Wrong!"
        );
      } else {
        console.log("enter here...");
        dispatch(setUser(response?.data?.result));
        toast.success("အောင်မြင်စွာ အကောင့်ဝင်ပါ။");
        resetStates();
        closeHandler();
      }
    } catch (error: any) {
      console.log(error, "err");
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <motion.div
        layout
        variants={variants}
        initial="hidden"
        animate={controls}
        transition={{
          type: "spring",
          stiffness: 700,
          damping: 30,
        }}
        className={classes.auth_modal}
      >
        <div className={classes.auth_sub_modal}>
          <button
            className={classes.close_icon_container}
            onClick={closeHandler}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
          {authModalType === "signup" ? (
            <motion.div className={classes.form_modal}>
              <p className={classes.title}>အကောင့်အသစ်တစ်ခုဖန်တီးပါ။</p>

              <form className={classes.form} onSubmit={signupHandler}>
                <InputText
                  required
                  type="text"
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="အသုံးပြုသူအမည်"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <InputText
                  type="email"
                  required
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="example@gmail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <InputText
                  type="password"
                  required
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="စကားဝှက်"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <InputText
                  type="password"
                  required
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="စကားဝှက်ကို ပြန်လည်အတည်ပြုပါ။"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <button
                  type="submit"
                  disabled={signupLoading}
                  className={classes.signup_btn}
                >
                  {signupLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    "ဆိုင်းအပ်"
                  )}
                </button>

                <div className={classes.grid_container}>
                  <span className={classes.grid_item}></span>
                  <span className={classes.or}>သို့မဟုတ်</span>
                  <span className={classes.grid_item}></span>
                </div>
                <p className={classes.link_text}>
                  User ဖြစ်နေပြီ၊{" "}
                  <span
                    className={classes.link}
                    onClick={() => {
                      dispatch(
                        setAuthModal({
                          authModal: true,
                          authModalType: "signin",
                        })
                      );
                    }}
                  >
                    ဆိုင်းအင်လုပ်ခြင်း
                  </span>
                </p>
              </form>
            </motion.div>
          ) : (
            <motion.div className={classes.form_modal}>
              <p className={classes.title}>ကြိုဆိုပါတယ်၊ အကောင့်ဝင်ပါ။</p>

              <form className={classes.form} onSubmit={loginHandler}>
                <InputText
                  type="text"
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="အသုံးပြုသူအမည် သို့မဟုတ် example@gmail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <InputText
                  type="password"
                  className={`p-inputtext-lg ${classes.input}`}
                  placeholder="စကားဝှက်"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <button
                  type="submit"
                  disabled={loginLoading}
                  className={classes.signup_btn}
                >
                  {loginLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    "ဆိုင်းအင်လုပ်ခြင်း"
                  )}
                </button>

                <div className={classes.grid_container}>
                  <span className={classes.grid_item}></span>
                  <span className={classes.or}>သို့မဟုတ်</span>
                  <span className={classes.grid_item}></span>
                </div>
                <p className={classes.link_text}>
                  အသုံးပြုသူအသစ်လား။{" "}
                  <span
                    className={classes.link}
                    onClick={() => {
                      dispatch(
                        setAuthModal({
                          authModal: true,
                          authModalType: "signup",
                        })
                      );
                    }}
                  >
                    အကောင့်ပြုလုပ်ပါ
                  </span>
                </p>
              </form>
            </motion.div>
          )}

          <div className={classes.benefits_modal}>
            <p className={classes.benefits_title}>သင့်အကောင့်၏အကျိုးကျေးဇူးများ</p>

            <div className={classes.benefits}>
              <div className={classes.benefit}>
                <div className={classes.benefit_title}>
                  <i className={`pi pi-circle-fill ${classes.icon}`} />
                  <p className={classes.bt}>အသိုက်အဝန်းကြီး</p>
                </div>
                <p className={classes.bd}>
                  ကြီးမားသောအသိုင်းအဝိုင်းနှင့် အပြန်အလှန်ဆက်ဆံပြီး ခေတ်ရေစီးကြောင်းကို သိရှိပါ။
                </p>
              </div>

              <div className={classes.benefit}>
                <div className={classes.benefit_title}>
                  <i className={`pi pi-circle-fill ${classes.icon}`} />
                  <p className={classes.bt}>ဇာတ်လမ်းတိုများကို ကြည့်ရှုပါ။</p>
                </div>
                <p className={classes.bd}>
                  ရုပ်ရှင်နှင့် ဇာတ်လမ်းတွဲများ၏ ဘောင်းဘီတို (ကလစ်များ) ကိုကြည့်ပါ။
                </p>
              </div>

              <div className={classes.benefit}>
                <div className={classes.benefit_title}>
                  <i className={`pi pi-circle-fill ${classes.icon}`} />
                  <p className={classes.bt}>သင်၏ စောင့်ကြည့်စာရင်း</p>
                </div>
                <p className={classes.bd}>
                 သင့်စိတ်ကြိုက်ရုပ်ရှင်များ ကြည့်ရှုစာရင်းကို ဖန်တီးပါ။
                </p>
              </div>

              <div className={classes.benefit}>
                <div className={classes.benefit_title}>
                  <i className={`pi pi-circle-fill ${classes.icon}`} />
                  <p className={classes.bt}>အဆင့်သတ်မှတ်ချက်များ</p>
                </div>
                <p className={classes.bd}>
                  သင်မြင်ဖူးသမျှကို အဆင့်သတ်မှတ်ပြီး မှတ်သားပါ။
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default AuthModal;
